export default __webpack_public_path__ + "static/media/invoice-disabled.7a07187f.png";